import Slider from './Slider'
import SliderItem from './SliderItem'
import SliderDots from './SliderDots'
import SliderDot from './SliderDot'
import SliderPrev from './SliderPrev'
import SliderNext from './SliderNext'

export default (editor, config = {}) => {
  const dc = editor.DomComponents
  const defaultType = dc.getType('default')
  const defaultModel = defaultType.model
  const defaultView = defaultType.view
  const opts = {
    ...config,
    defaultModel,
    defaultView
  }

  Slider(editor, opts)
  SliderItem(editor, opts)
  SliderDots(dc, opts)
  SliderDot(dc, opts)
  SliderPrev(dc, opts)
  SliderNext(dc, opts)
}
